export enum SortEquipmentRelocateColumnsEnum {
    EquipmentName = "equipment.name",
    SourceSportObjectName = "sourceSportObject.name",
    TargetSportObjectName = "targetSportObject.name",
    Status = "relocationRequest.status",
    RejectReason = "relocationRequest.rejectReason",
    CreatedAt = "relocationRequest.createdAt",
}